module.exports = __webpack_public_path__ + "hero-6f5ea72c.webp";